import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UntypedFormControl, Validators } from '@angular/forms';

import { ToastrService } from 'ngx-toastr';
import { ViewUpdateTprApiService } from '../../../../../../modules/api/view-update-tpr-api.service';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'tpr-duplicate-dialog',
    templateUrl: './tpr-duplicate-dialog.component.html',
    styleUrls: ['../../../tprecm.style.scss']
})
export class TprDuplicateDialogComponent implements OnInit {

    constructor(
        public readonly dialog: MatDialogRef<TprDuplicateDialogComponent>,
        private readonly viewUpdateTprApiService: ViewUpdateTprApiService,
        private readonly toastr: ToastrService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    loading = false;

    newFixtureNo: UntypedFormControl;
    selectedToolId: string;

    ngOnInit() {
        if (!this.data.selectedToolId) {
            this.toastr.error('Please select a tool ID before duplicating a tool');
            return;
        }

        this.selectedToolId = this.data.selectedToolId;
        this.newFixtureNo = new UntypedFormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z0-9_-]*$')]);
    }

    duplicateTpr() {
        if (!this.newFixtureNo.valid) {
            return;
        }

        this.loading = true;

        this.viewUpdateTprApiService.duplicateTpr(this.newFixtureNo.value.toUpperCase(), this.selectedToolId)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => this.dialog.close(response));
    }

}
